import React from 'react';
import { useSelector } from 'react-redux';

import LoadingWrapper from 'dpl/components/LoadingWrapper';
import usePrismicMetaTags from 'dpl/prismic/hooks/usePrismicMetaTags';

import usePrismicHub from '../hooks/usePrismicHub';
import HubBody from './HubBody';

export default function Hub() {
  const prismicDocumentUid = useSelector(
    ({ server }) => server.prismicDocumentUid
  );
  const prismicQuery = usePrismicHub(prismicDocumentUid);
  const { hub, isSuccess } = prismicQuery;

  usePrismicMetaTags(prismicQuery);

  return (
    <div className="PrismicHub">
      <LoadingWrapper isLoading={!isSuccess} className="fixed absolute--fill">
        <div className="mt12">
          <HubBody hub={hub} slices={hub.data.body} />
        </div>
      </LoadingWrapper>
    </div>
  );
}
